import { APP_METRICS_CHARTS, APP_METRICS_STEPS } from "./app-metrics-route-query.js";
import { ID_PART_PATTERN } from "@zion/sdk-contracts";
import { z } from "zod";
//#region src/app-metrics-route-query.schemas.ts
/**
* Zod schemas of the app metrics route query. The constants and the types are in
* `app-metrics-route-query.ts`.
*
* No schema here uses `.transform()` or a refinement: core-api binds the query schema with
* `@Query({ schema })`, and `createOpenApiDocument()` throws on a transform at boot.
*/
/** Accepts exactly one of `APP_METRICS_CHARTS`, as spelled. Any other value fails. */
const AppMetricsRouteChartSchema = z.enum(APP_METRICS_CHARTS);
/** Accepts exactly one of `APP_METRICS_STEPS`, as spelled. Any other value fails. */
const AppMetricsRouteStepSchema = z.enum(APP_METRICS_STEPS);
/** An app id part: the operator's `ID_PART_PATTERN` grammar, bounded before the match. */
const idPartSchema = z.string().min(1).max(253).regex(ID_PART_PATTERN);
/** An instant text of 1 to `APP_METRICS_INSTANT_MAX_LENGTH` characters. */
const instantTextSchema = z.string().min(1).max(64);
/**
* The query of the route, strict: any other key fails, so an `expr`, `query`, `promql` or
* `selector` key is a 400.
*
* - `chart` (required): one of `APP_METRICS_CHARTS`.
* - `slug` (required): the app slug, which the broker resolves from the app id. The operator's
*   id-part grammar, 1 to 253 characters, with no `--`, so one app scope never matches the pods of
*   another app.
* - `fixtureId` (optional): the same grammar; it narrows the scope to one fixture.
* - `start`, `end` (required): instant texts of 1 to 64 characters. core-api then checks them
*   against `RFC3339_INSTANT_PATTERN` and the window rules.
* - `step` (required): one of `APP_METRICS_STEPS`.
*
* Output: the same object, unchanged. Errors: a `ZodError` that names each failed path.
*/
const AppMetricsRouteQuerySchema = z.object({
	chart: AppMetricsRouteChartSchema,
	slug: idPartSchema,
	fixtureId: idPartSchema.optional(),
	start: instantTextSchema,
	end: instantTextSchema,
	step: AppMetricsRouteStepSchema
}).strict();
//#endregion
export { AppMetricsRouteChartSchema, AppMetricsRouteQuerySchema, AppMetricsRouteStepSchema };

//# sourceMappingURL=app-metrics-route-query.schemas.js.map